import React, { useState } from "react";

// import JS files

// import others files
import Template from "../../shares/Template";
import WaitingList from "../../share-users/waiting/WaitingList";

const Dashboard = (props) => {
  return (
    <>
      <WaitingList/>
    </>
  );
};

export default Dashboard;
